import { readLocalStorage } from "../browserUtils";
import { canPaste, clipboardKey } from "./commons";
async function clipboardPaste() {
    if (canPaste()) {
        const text = await navigator.clipboard.readText();
        return JSON.parse(text);
    }
    else {
        return readLocalStorage(clipboardKey);
    }
}
export default clipboardPaste;
//# sourceMappingURL=clipboardPaste.js.map